import { render, staticRenderFns } from "./BtnAnexoDuplicadoJustificativa.vue?vue&type=template&id=0ae9ceb0"
import script from "./BtnAnexoDuplicadoJustificativa.vue?vue&type=script&lang=js"
export * from "./BtnAnexoDuplicadoJustificativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports